import React, { useState } from 'react';
import { faqs } from '../data/mock';
import { Plus, Minus } from 'lucide-react';

const FAQItem = ({ faq, isOpen, onClick }) => {
  return (
    <div 
      className={`rounded-2xl overflow-hidden transition-all duration-300 ${
        isOpen 
          ? 'bg-gradient-to-r from-[#1a1a1f] via-[#1a1a1f] to-purple-900/20 border border-purple-500/20' 
          : 'bg-[#1a1a1f] border border-white/5 hover:border-white/10'
      }`}
    >
      <button
        onClick={onClick}
        className="w-full px-6 py-5 flex items-center justify-between text-left"
      >
        <span className="text-white font-medium pr-4">{faq.question}</span>
        <span className={`flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
          {isOpen ? (
            <Minus className="w-5 h-5 text-gray-400" />
          ) : (
            <Plus className="w-5 h-5 text-gray-400" />
          )}
        </span>
      </button>
      
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-48' : 'max-h-0'}`}>
        <p className="px-6 pb-5 text-gray-400 leading-relaxed">
          {faq.answer}
        </p>
      </div>
    </div>
  );
};

const FAQSection = () => {
  const [openFaq, setOpenFaq] = useState(1);

  return (
    <section className="bg-[#0a0a0b] py-24 px-6" id="faq-section">
      <div className="max-w-3xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#1a1a1f] border border-white/10 text-sm text-gray-300 mb-6">
            Frequently Asked Questions
          </div>
          <h2 className="text-4xl md:text-5xl text-white font-normal mb-4">
            Everything you <span className="italic font-light">need</span> to know.
          </h2>
          <p className="text-gray-400">
            Got questions? We've got answers. Here's everything you need to know before getting started.
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-3">
          {faqs.map((faq) => (
            <FAQItem
              key={faq.id}
              faq={faq}
              isOpen={openFaq === faq.id}
              onClick={() => setOpenFaq(openFaq === faq.id ? null : faq.id)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
